module.exports = "faq"